import React, { FC, useEffect, useState } from 'react';
import { Box, styled, SxProps, Theme } from '@mui/material';
import { transition } from 'src/theme';

type Props = {
  children?: any;
  loading?: boolean;
  delay?: number;
  isWithReFade?: boolean;
  sx?: SxProps<Theme>;
};
const FadeBox: FC<Props> = ({
  children,
  loading = false,
  delay = 100,
  isWithReFade = false,
  sx = {},
}) => {
  const [fade, setFade] = useState(false);

  const WrappingBox = styled(Box)({
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    transition: transition({ property: 'opacity' }),
    // transition: 'opacity 250ms ease-in-out',
    opacity: 0,
    transform: 'scale(0.95)',
    transformOrigin: 'left',
    direction: 'rtl',
    '&.fade-in': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '&.fade-in.fade-out': {
      opacity: 0,
      transform: 'scale(0.95)',
    },
  });

  useEffect(() => {
    if (!loading) {
      // Start the fade-in effect after the skeleton disappears
      const timer = setTimeout(() => setFade(true), delay);
      return () => clearTimeout(timer);
    } else {
      if (isWithReFade) {
        // Reset the fade effect when the skeleton appears
        setFade(false);
      }
    }
  }, [loading, isWithReFade]);

  return (
    <WrappingBox
      className={fade ? 'fade-in' : isWithReFade ? 'fade-in fade-out' : ''}
      sx={{ ...sx }}
    >
      {children}
    </WrappingBox>
  );
};

export default FadeBox;
